define(function(require, exports, module) {
    'use strict';

    var QuickDepositService = require('modules/cashier/quick-deposit/swiss-theme/quick-deposit.service');

    module.exports = new QuickDepositService();
});
